export default [
  {
    icon: 'mdi-briefcase-account-outline',
    title: 'Daftar Riwayat Hidup (CV)',
    desc: 'Pada langkah ini Anda diharuskan melengkapi semua informasi Biodata Diri Anda',
    color: 'green',
    deepColor: '',
    akses: true,
    disable: true,
    key: 'cv',
    link: 'cv',
    to: { name: 'cv' },
  },
  {
    icon: 'mdi-web',
    title: 'Portal Sekolah Penggerak',
    desc: '',
    color: 'secondary',
    deepColor: 'darken-2',
    dividerTop: true,
    sidebar: true,
    akses: true,
    newtab: true,
    href: '#PORTAL_URL#',
  },
  {
    icon: 'mdi-webhook',
    title: 'ke Aplikasi SIMPKB',
    desc: '',
    color: 'secondary',
    deepColor: 'darken-2',
    sidebar: true,
    akses: true,
    link: 'app-sim-pkb',
    href: '#SIM_PKB_URL#',
  },
];
